<template>
  <div class="border">
    <h4>Платиковые карты</h4>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      title_add="Добавить карту"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/cards`;
    this.setLink += `/${this.id}/cards`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "full_name",
          label: "Владелец карты (имя и фамилия)",
          type: "field",
        },
        {
          col: " col-12 col-md-12",
          key: "phone",
          labelKey: "card_phone",
          label: "Номер телефона привязанный в карте",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
        {
          col: " col-12 col-md-8",
          key: "card_number",
          label: "Номер карты",
          labelKey: "card_number",
          type: "mask",
          mask: "#### #### #### ####",
          placeholder: "#### #### #### ####",
        },
        {
          col: " col-12 col-md-4",
          key: "exp",
          labelKey: "card_exp",
          label: "Дата окончания",
          type: "mask",
          mask: "##/##",
          placeholder: "MM/ГГ",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_field",
      itemLink: "clients",
      setLink: "clients",
      columns: [
        {
          key: "card_number",
          titleKey: "card_number",
          title: "Номер карты",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          full: true,
        },
        {
          key: "exp",
          titleKey: "card_exp",
          title: "Дата",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          full: true,
        },
        {
          key: "phone",
          titleKey: "card_phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          full: true,
        },

        {
          // detail: true,
          //remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
